import API from "./axios";

/**
 * Phase 36da.99.bi — Translation proxy client.
 *
 * Defaults to English → Marathi (the only direction the Instructions page
 * uses currently).  Backend talks to MyMemory; a 502 means the public API
 * is unreachable — the caller should fall back to manual entry and surface
 * a one-line "translation unavailable" hint.
 */
const translateApi = {
  /**
   * @param {string} text  — source text
   * @param {string} [from] — ISO code, default "en"
   * @param {string} [to]   — ISO code, default "mr"
   */
  translate: (text, from = "en", to = "mr") =>
    API.post("/translate", { text, from, to }),
};

export default translateApi;